import {CurrencyCodeType} from 'shared/web';

import {DocumentRestrictionFormType} from './types';

export const emptyRestrictionItem = (currency: CurrencyCodeType): DocumentRestrictionFormType => ({
  amount: {
    amount: '',
    currency,
  },
  documentTypes: [],
  type: 'off',
  validFrom: null,
});
